import React, { useState, useEffect } from "react";
import "./navbar.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
// import Button from 'react-bootstrap/Button';
import Offcanvas from "react-bootstrap/Offcanvas";
import useAuth from "../../../hooks/useAuth";
import { useWeb3React } from "@web3-react/core";
import { setupNetwork } from "../../../utils/wallet";
import Environment from "../../../utils/Environment";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage?.getItem("authToken");

  const { login, logout } = useAuth();
  let { account, chainId } = useWeb3React();

  const [isModalOpen, setModalOpen] = useState(false);
  const [showsidebar, setShowSidebar] = useState(false);

  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);
  console.log(showsidebar, "showsidebar");

  const handleClose = () => {
    setModalOpen(false);
    handleCloseSidebar();
  };

  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;

  // Function to handle clicks outside the modal content
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      setModalOpen(false);
    }
  };

  const connectMetaMask1 = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      let res = await setupNetwork();
      console.log(res, "res in setupNetwork");

      if (res) {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose();
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      await logout("walletconnect");
      localStorage.clear();
      handleClose();
    } else {
      try {
        handleClose();
        login("walletconnect");
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
      }
    }
  };

  const logoutHandle = async () => {
    const connectorId = window.localStorage.getItem("connectorId");
    await logout(connectorId);
    localStorage.removeItem("connectorId");
    localStorage.removeItem("flag");
  };

  const logoutUserHandle = () => {
    localStorage?.removeItem("authToken");
    localStorage?.removeItem("referalAddress");
    window?.location?.reload();

    localStorage.removeItem("profileImage");
    localStorage.removeItem("userName");
  };

  useEffect(() => {
    // Update the timer every second
    if (chainId != 11155111) {
      setupNetwork(11155111);
    }
  }, [chainId]);

  return (
    <section className="main-navbar-mobile main-navbar">
      <div className="container-fluid  ">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-12  m-auto    nav_boder ">
            <nav className="navbar  navbar-expand-xl ">
              <a
                href="#"
                className=" razaaaaaaaa11111     navbar-brand animate__flash"
              >
                <Link to="/">
                  {/* <img
                    src="\Logo\Logo.png"
                    alt="img"
                    width={'204px'}
                    className="img-fluid animate__animated animate__bounce"
                  /> */}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="167"
                    height="32"
                    viewBox="0 0 167 32"
                    fill="none"
                  >
                    <path
                      d="M49.1367 10.8367V15.2252H54.2997V17.2258H49.1367V21.8079H54.945V23.8086H46.6843V8.83605H54.945V10.8367H49.1367Z"
                      fill="#646464"
                    />
                    <path
                      d="M62.2681 24.0022C61.3359 24.0022 60.4969 23.8373 59.7512 23.5074C59.0198 23.1632 58.4389 22.7043 58.0087 22.1306C57.5784 21.5426 57.349 20.8901 57.3203 20.173H59.8587C59.9018 20.675 60.1384 21.098 60.5686 21.4422C61.0132 21.7721 61.5654 21.937 62.2251 21.937C62.9135 21.937 63.4441 21.8079 63.817 21.5498C64.2042 21.2773 64.3978 20.9331 64.3978 20.5172C64.3978 20.0726 64.1827 19.7428 63.7525 19.5276C63.3366 19.3125 62.6697 19.0759 61.7518 18.8177C60.8626 18.5739 60.1384 18.3373 59.5791 18.1078C59.0198 17.8784 58.5321 17.527 58.1162 17.0537C57.7147 16.5805 57.5139 15.9566 57.5139 15.1822C57.5139 14.5511 57.7003 13.9775 58.0732 13.4612C58.4461 12.9305 58.9767 12.5146 59.6651 12.2135C60.3679 11.9123 61.171 11.7617 62.0745 11.7617C63.4226 11.7617 64.5054 12.1059 65.3229 12.7943C66.1547 13.4684 66.5992 14.3934 66.6566 15.5694H64.2042C64.1612 15.0387 63.9461 14.6157 63.5588 14.3002C63.1716 13.9846 62.6482 13.8269 61.9885 13.8269C61.3431 13.8269 60.8483 13.9488 60.5041 14.1926C60.1599 14.4364 59.9878 14.7591 59.9878 15.1607C59.9878 15.4762 60.1025 15.7415 60.332 15.9566C60.5615 16.1717 60.8411 16.3438 61.171 16.4729C61.5008 16.5876 61.9885 16.7382 62.6338 16.9247C63.4943 17.1541 64.197 17.3908 64.742 17.6346C65.3013 17.864 65.7818 18.2082 66.1833 18.6672C66.5849 19.1261 66.7929 19.7356 66.8072 20.4957C66.8072 21.1697 66.6208 21.7721 66.2479 22.3027C65.875 22.8334 65.3444 23.2493 64.656 23.5504C63.9819 23.8516 63.186 24.0022 62.2681 24.0022Z"
                      fill="#646464"
                    />
                    <path
                      d="M72.3182 13.956V20.5172C72.3182 20.9618 72.4186 21.2845 72.6194 21.4853C72.8345 21.6717 73.193 21.7649 73.695 21.7649H75.2008V23.8086H73.2647C72.1604 23.8086 71.3143 23.5504 70.7263 23.0341C70.1383 22.5178 69.8443 21.6789 69.8443 20.5172V13.956H68.446V11.9553H69.8443V9.00815H72.3182V11.9553H75.2008V13.956H72.3182Z"
                      fill="#646464"
                    />
                    <path
                      d="M76.6437 17.8282C76.6437 16.6378 76.8875 15.5837 77.3751 14.6659C77.877 13.748 78.5511 13.0381 79.3972 12.5362C80.2577 12.0199 81.2043 11.7617 82.2369 11.7617C83.1691 11.7617 83.9794 11.9482 84.6677 12.321C85.3705 12.6796 85.9298 13.1313 86.3457 13.6763V11.9553H88.8196V23.8086H86.3457V22.0446C85.9298 22.6039 85.3633 23.07 84.6462 23.4429C83.9292 23.8158 83.1117 24.0022 82.1938 24.0022C81.1756 24.0022 80.2434 23.744 79.3972 23.2277C78.5511 22.6971 77.877 21.9657 77.3751 21.0335C76.8875 20.087 76.6437 19.0185 76.6437 17.8282ZM86.3457 17.8712C86.3457 17.0537 86.1736 16.3438 85.8294 15.7415C85.4996 15.1391 85.0621 14.6802 84.5172 14.3647C83.9722 14.0492 83.3842 13.8914 82.7532 13.8914C82.1221 13.8914 81.5341 14.0492 80.9892 14.3647C80.4442 14.6659 79.9996 15.1176 79.6554 15.72C79.3255 16.308 79.1606 17.0107 79.1606 17.8282C79.1606 18.6456 79.3255 19.3627 79.6554 19.9794C79.9996 20.5961 80.4442 21.0694 80.9892 21.3992C81.5485 21.7147 82.1365 21.8725 82.7532 21.8725C83.3842 21.8725 83.9722 21.7147 84.5172 21.3992C85.0621 21.0837 85.4996 20.6248 85.8294 20.0224C86.1736 19.4057 86.3457 18.6887 86.3457 17.8712Z"
                      fill="#646464"
                    />
                    <path
                      d="M94.9019 13.956V20.5172C94.9019 20.9618 95.0023 21.2845 95.203 21.4853C95.4182 21.6717 95.7767 21.7649 96.2787 21.7649H97.7845V23.8086H95.8484C94.7441 23.8086 93.898 23.5504 93.31 23.0341C92.722 22.5178 92.428 21.6789 92.428 20.5172V13.956H91.0297V11.9553H92.428V9.00815H94.9019V11.9553H97.7845V13.956H94.9019Z"
                      fill="#646464"
                    />
                    <path
                      d="M110.909 17.5915C110.909 18.0361 110.88 18.4377 110.822 18.7962H101.766C101.838 19.7428 102.189 20.5029 102.82 21.0765C103.451 21.6502 104.225 21.937 105.143 21.937C106.463 21.937 107.395 21.3849 107.94 20.2806H110.586C110.227 21.3705 109.575 22.2669 108.628 22.9696C107.696 23.658 106.534 24.0022 105.143 24.0022C104.01 24.0022 102.992 23.7512 102.088 23.2493C101.199 22.733 100.497 22.0159 99.9803 21.098C99.4783 20.1658 99.2273 19.0902 99.2273 17.8712C99.2273 16.6522 99.4712 15.5837 99.9588 14.6659C100.461 13.7337 101.156 13.0166 102.045 12.5146C102.949 12.0127 103.982 11.7617 105.143 11.7617C106.262 11.7617 107.259 12.0055 108.133 12.4931C109.008 12.9807 109.689 13.6691 110.177 14.5583C110.665 15.4331 110.909 16.4442 110.909 17.5915ZM108.349 16.8171C108.334 15.9136 108.012 15.1893 107.38 14.6444C106.749 14.0994 105.968 13.8269 105.036 13.8269C104.19 13.8269 103.465 14.0994 102.863 14.6444C102.261 15.175 101.902 15.8992 101.787 16.8171H108.349Z"
                      fill="#646464"
                    />
                    <path
                      d="M123.836 23.9592C122.832 23.9592 121.929 23.7871 121.126 23.4429C120.323 23.0843 119.692 22.5824 119.233 21.937C118.774 21.2916 118.544 20.5387 118.544 19.6782H121.169C121.226 20.3236 121.477 20.8542 121.922 21.2701C122.381 21.686 123.019 21.894 123.836 21.894C124.683 21.894 125.342 21.6932 125.815 21.2916C126.289 20.8757 126.525 20.3451 126.525 19.6997C126.525 19.1978 126.375 18.7891 126.074 18.4735C125.787 18.158 125.421 17.9142 124.977 17.7421C124.546 17.57 123.944 17.3836 123.169 17.1828C122.194 16.9247 121.398 16.6665 120.782 16.4084C120.179 16.1359 119.663 15.72 119.233 15.1607C118.802 14.6013 118.587 13.8556 118.587 12.9234C118.587 12.0629 118.802 11.31 119.233 10.6646C119.663 10.0192 120.265 9.52444 121.04 9.18024C121.814 8.83605 122.711 8.66395 123.729 8.66395C125.177 8.66395 126.36 9.02966 127.278 9.76107C128.211 10.4782 128.727 11.4677 128.827 12.7298H126.117C126.074 12.1848 125.815 11.7187 125.342 11.3315C124.869 10.9442 124.245 10.7506 123.471 10.7506C122.768 10.7506 122.194 10.9299 121.75 11.2884C121.305 11.647 121.083 12.1633 121.083 12.8373C121.083 13.2963 121.219 13.6763 121.492 13.9775C121.778 14.2643 122.137 14.4938 122.567 14.6659C122.997 14.838 123.585 15.0244 124.331 15.2252C125.321 15.4977 126.124 15.7702 126.741 16.0427C127.372 16.3151 127.902 16.7382 128.332 17.3119C128.777 17.8712 128.999 18.6241 128.999 19.5707C128.999 20.3308 128.791 21.0478 128.375 21.7219C127.974 22.3959 127.379 22.9409 126.59 23.3568C125.815 23.7584 124.898 23.9592 123.836 23.9592Z"
                      fill="#646464"
                    />
                    <path
                      d="M134.345 7.88951V23.8086H131.893V7.88951H134.345Z"
                      fill="#646464"
                    />
                    <path
                      d="M138.813 10.3849C138.368 10.3849 137.995 10.2343 137.694 9.93317C137.393 9.632 137.243 9.25912 137.243 8.81454C137.243 8.36995 137.393 7.99707 137.694 7.6959C137.995 7.39473 138.368 7.24414 138.813 7.24414C139.243 7.24414 139.609 7.39473 139.91 7.6959C140.211 7.99707 140.362 8.36995 140.362 8.81454C140.362 9.25912 140.211 9.632 139.91 9.93317C139.609 10.2343 139.243 10.3849 138.813 10.3849ZM140.018 11.9553V23.8086H137.565V11.9553H140.018Z"
                      fill="#646464"
                    />
                    <path
                      d="M142.42 17.8712C142.42 16.6522 142.664 15.5837 143.151 14.6659C143.653 13.7337 144.342 13.0166 145.217 12.5146C146.091 12.0127 147.095 11.7617 148.228 11.7617C149.662 11.7617 150.846 12.1059 151.778 12.7943C152.724 13.4684 153.363 14.4364 153.692 15.6985H151.046C150.831 15.1105 150.487 14.6515 150.014 14.3217C149.54 13.9918 148.945 13.8269 148.228 13.8269C147.224 13.8269 146.421 14.1854 145.819 14.9025C145.231 15.6052 144.937 16.5948 144.937 17.8712C144.937 19.1476 145.231 20.1443 145.819 20.8614C146.421 21.5785 147.224 21.937 148.228 21.937C149.648 21.937 150.587 21.3132 151.046 20.0654H153.692C153.348 21.2701 152.703 22.231 151.756 22.9481C150.81 23.6508 149.634 24.0022 148.228 24.0022C147.095 24.0022 146.091 23.7512 145.217 23.2493C144.342 22.733 143.653 22.0159 143.151 21.098C142.664 20.1658 142.42 19.0902 142.42 17.8712Z"
                      fill="#646464"
                    />
                    <path
                      d="M167 17.5915C167 18.0361 166.971 18.4377 166.914 18.7962H157.857C157.929 19.7428 158.28 20.5029 158.911 21.0765C159.542 21.6502 160.317 21.937 161.235 21.937C162.554 21.937 163.486 21.3849 164.031 20.2806H166.677C166.319 21.3705 165.666 22.2669 164.72 22.9696C163.788 23.658 162.626 24.0022 161.235 24.0022C160.102 24.0022 159.084 23.7512 158.18 23.2493C157.291 22.733 156.588 22.0159 156.072 21.098C155.57 20.1658 155.319 19.0902 155.319 17.8712C155.319 16.6522 155.563 15.5837 156.05 14.6659C156.552 13.7337 157.248 13.0166 158.137 12.5146C159.041 12.0127 160.073 11.7617 161.235 11.7617C162.353 11.7617 163.35 12.0055 164.225 12.4931C165.1 12.9807 165.781 13.6691 166.269 14.5583C166.756 15.4331 167 16.4442 167 17.5915ZM164.44 16.8171C164.426 15.9136 164.103 15.1893 163.472 14.6444C162.841 14.0994 162.059 13.8269 161.127 13.8269C160.281 13.8269 159.557 14.0994 158.954 14.6444C158.352 15.175 157.994 15.8992 157.879 16.8171H164.44Z"
                      fill="#646464"
                    />
                    <path
                      d="M24.1811 19.8955C23.6774 20.4302 23.1788 20.9701 22.67 21.4997C22.4943 21.6831 22.5511 21.9026 22.5511 22.1119C22.5485 25.067 22.5408 28.0248 22.5589 30.9799C22.5615 31.4061 22.4917 31.5663 22.0138 31.5585C20.2289 31.525 18.4439 31.5353 16.6615 31.5534C16.2998 31.556 16.2146 31.4475 16.2146 31.0987C16.2275 27.5288 16.2249 23.9614 16.2172 20.3915C16.2172 20.1564 16.2843 19.9937 16.4497 19.8232C18.5343 17.7127 20.6137 15.5997 22.6855 13.4763C22.8921 13.2645 23.1065 13.1793 23.3984 13.1818C24.8398 13.1922 26.2838 13.1715 27.7252 13.1973C28.1411 13.2051 28.2419 13.0708 28.2341 12.6729C28.2109 11.2496 28.2367 9.82371 28.216 8.40038C28.2109 8.06198 28.3168 7.82949 28.557 7.60476C29.0685 7.1217 29.5515 6.61023 30.0553 6.12201C30.1767 6.00319 30.2722 5.76037 30.4608 5.82495C30.6675 5.89728 30.5564 6.1401 30.5564 6.30542C30.5564 10.7407 30.5486 15.1735 30.5486 19.6088C30.5486 23.4112 30.5512 27.2162 30.5719 31.0187C30.5745 31.4346 30.4789 31.5637 30.0449 31.5585C28.3323 31.5327 26.6196 31.5301 24.907 31.5585C24.4549 31.5663 24.3852 31.4113 24.3852 31.0083C24.3929 27.5288 24.38 24.0518 24.3723 20.5723C24.3723 20.3811 24.3723 20.19 24.3723 20.0014C24.3051 19.9678 24.2431 19.9317 24.1811 19.8955Z"
                      fill="#F6881F"
                    />
                    <path
                      d="M14.4168 15.8579C14.4168 20.9054 14.4117 25.9555 14.4272 31.0031C14.4297 31.4474 14.3342 31.5688 13.8769 31.561C12.11 31.5275 10.3432 31.5352 8.57626 31.5481C8.22753 31.5507 8.11646 31.4629 8.11646 31.0986C8.12937 22.8583 8.13195 14.6206 8.12937 6.38024C8.12937 6.14258 8.20945 5.98501 8.36702 5.82227C9.58112 4.58235 10.7926 3.33984 11.999 2.08958C12.5543 1.51353 13.0942 0.92457 13.6393 0.340772C13.7943 0.175449 13.9544 -0.0570367 14.1895 0.012709C14.4866 0.10312 14.4323 0.407935 14.4323 0.658503C14.4323 5.72411 14.4323 10.7923 14.4323 15.8579C14.4297 15.8579 14.4246 15.8579 14.4168 15.8579Z"
                      fill="#646464"
                    />
                    <path
                      d="M6.26168 10.3997C6.46317 11.4045 6.396 12.3551 6.33142 13.298C6.30043 13.732 6.34692 14.1556 6.34692 14.5844C6.34176 20.0633 6.33659 25.5448 6.35467 31.0237C6.35726 31.4887 6.22551 31.5765 5.78896 31.5688C4.00398 31.5404 2.21901 31.5429 0.436619 31.561C0.0749744 31.5636 -0.00252151 31.4577 6.16648e-05 31.1141C0.0129775 26.3921 0.0129773 21.6675 0.0129773 16.9454C0.0129773 16.7284 0.0258932 16.5476 0.206716 16.3694C2.16476 14.4294 4.10989 12.4765 6.06277 10.5262C6.09894 10.4927 6.14802 10.472 6.26168 10.3997Z"
                      fill="#646464"
                    />
                    <path
                      d="M16.2122 11.9419C19.7175 8.16275 23.4864 4.85887 26.9117 1.21143C26.9556 1.23467 26.9995 1.25792 27.046 1.28375C27.046 1.43616 27.046 1.58857 27.046 1.74098C27.046 4.96736 27.0382 8.19375 27.0563 11.4176C27.0589 11.836 26.9608 11.9574 26.5268 11.9549C23.1402 11.9342 19.7537 11.9419 16.2122 11.9419Z"
                      fill="#646464"
                    />
                  </svg>
                </Link>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                onClick={handleShowSidebar}
              >
                <span className="togg">
                  <span className="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 17H19M5 12H19M5 7H19"
                        stroke="#000"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </span>
              </button>
              <div
                className="collapse navbar-collapse marg p-0"
                id="navbarSupportedContent"
              >
                {/* <Link to="/" className="newwwwhommee">
                  <button className="homebtnns">
                    Home
                  </button>
                </Link> */}

                <ul className="navbar-nav m-auto">
                  <li class="nav-item active">
                    <HashLink
                      to="#navbar"
                      style={
                        isActive("")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Home
                    </HashLink>
                  </li>
                  <li className="nav-item">
                    <HashLink
                      to="#about"
                      style={
                        isActive("#about")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      About us
                    </HashLink>
                  </li>
                  <li className="nav-item">
                    <HashLink
                      to="#benefits"
                      style={
                        isActive("#benefits")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Benefits
                    </HashLink>
                  </li>

                  <li className="nav-item">
                    <HashLink
                      to="#information"
                      style={
                        isActive("#information")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Fraction
                    </HashLink>
                  </li>
                  <li className="nav-item ">
                    <HashLink
                      to="#roadmap"
                      style={
                        isActive("#roadmap")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Roadmap
                    </HashLink>
                  </li>
                  <li className="nav-item ">
                    <HashLink
                      to="#ourteamsec"
                      style={
                        isActive("#ourteamsec")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Team
                    </HashLink>
                  </li>
                  <li className="nav-item ">
                    <HashLink
                      to="#faqs"
                      style={
                        isActive("#faqs")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      FAQ
                    </HashLink>
                  </li>
                  <li className="nav-item ">
                    <HashLink
                      to="#"
                      style={
                        isActive("#")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Whitepaper
                    </HashLink>
                  </li>
                  <li className="nav-item ">
                    <HashLink
                      to="/join"
                      style={
                        isActive("#")
                          ? {
                              color: "#FF8A00",
                            }
                          : {}
                      }
                    >
                      Join whitelist
                    </HashLink>
                  </li>
                </ul>

                <div className="navrightbtsns">
                  <a href="" target="_blank">
                    <button className="twinsbtnss">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <path
                          d="M14.4436 1.78125H17.0624L11.341 8.32042L18.0718 17.2188H12.8017L8.67391 11.822L3.95083 17.2188H1.33041L7.45 10.2244L0.993164 1.78125H6.39708L10.1282 6.71413L14.4436 1.78125ZM13.5245 15.6513H14.9756L5.60858 3.26642H4.05137L13.5245 15.6513Z"
                          fill="#646464"
                        />
                      </svg>
                    </button>
                  </a>
                  <a href="" target="_blank">
                    <button className="twinsbtnss">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="19"
                        viewBox="0 0 23 19"
                        fill="none"
                      >
                        <path
                          d="M22.3742 1.99808L19.0734 17.5645C18.8244 18.6631 18.175 18.9366 17.2521 18.419L12.2228 14.7129L9.79608 17.0469C9.52752 17.3155 9.30291 17.5401 8.78534 17.5401L9.14666 12.418L18.468 3.99515C18.8732 3.63382 18.3801 3.43362 17.8381 3.79495L6.31463 11.0508L1.35369 9.49808C0.274593 9.16116 0.255062 8.41897 1.5783 7.9014L20.9826 0.42581C21.881 0.0888964 22.6672 0.626006 22.3742 1.99808Z"
                          fill="#646464"
                        />
                      </svg>
                    </button>
                  </a>

                  {token ? (
                    <div className="dashboardsideee">
                 
                      <a className="button-hedaer" href={Environment.UserDashboard}>
                        User Dashboard
                      </a>
                      <button
                        onClick={() => logoutUserHandle()}
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal"
                        class="btn button-hedaer"
                      >
                        Logout
                      </button>
                    </div>
                  ) : (
                    <>
                      <Link
                        to="/login"
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal"
                        class="btn button-hedaer"
                      >
                        Login
                      </Link>

                      <Link
                        to={Environment.UserDashboard + "signup"}
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal"
                        class="btn button-hedaer"
                      >
                        Signup
                      </Link>
                    </>
                  )}

                  {location?.pathname == "/villaa/:id" ? (
                    <>
                      {account ? (
                        <button
                          onClick={() => logoutHandle()}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          class="btn button-hedaer"
                        >
                          Disconnect
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            setModalOpen(true);
                            handleCloseSidebar();
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          class="btn button-hedaer"
                        >
                          Connect Wallet
                        </button>
                      )}
                    </>
                  ) : null}
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>

      <div className={`wallet-modal ${isModalOpen ? "show" : "hide"}`}>
        <div
          className="modal fade show"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden={!isModalOpen}
          style={{ display: isModalOpen ? "block" : "none" }}
          onClick={handleOutsideClick} // Handle outside click
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div className="cross-icon">
                  <h3 class="modal-title text-center" id="exampleModalLabel">
                    Connect your Wallet
                  </h3>
                  <button
                    className="cross-img1"
                    // type="button"
                    // data-bs-dismiss="modal"
                    // aria-label="Close"

                    type="button"
                    aria-label="Close"
                    onClick={() => setModalOpen(false)}
                  >
                    <img
                      src="/assets/navbar/Close_MD.svg"
                      className="img-fluid"
                      alt="close"
                      // onClick={() => isModalOpen(false)}
                    />
                  </button>
                </div>

                <div className="button-modal1 d-flex">
                  <button className="modal-button" onClick={connectMetaMask1}>
                    <img
                      src="\assets\navbar\metamask.svg"
                      className="img-fluid"
                    />
                    <h3 className=""> MetaMask</h3>
                    <p className="">Connect to your MetaMask wallet </p>
                  </button>
                  <button className="modal-button" onClick={trustWallet}>
                    <img
                      src="\assets\navbar\walletconnect.svg"
                      className="img-fluid"
                    />
                    <h3 className="">WalletConnect</h3>
                    <p className="">Connect to your MetaMask wallet </p>
                  </button>
                </div>
                <p className="text-center mt-3  connecting">
                  By connecting, I accept Estate Slice Fraction{" "}
                  <span className="common connectinggg">Terms of Service </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Offcanvas
        placement="top"
        className="mobile_sidebar"
        show={showsidebar}
        onHide={handleCloseSidebar}
      >
        <Offcanvas.Header closeButton>
          <div className="top-content">
            <a href="#" className="navbar-brand " onClick={handleCloseSidebar}>
              <Link to="/">
                {/* <img
                  src="\Logo\Logo.png"
                  alt="img"
                  width={'204px'}
                  className="img-fluid animate__animated animate__bounce"
                /> */}

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="113"
                  height="23"
                  viewBox="0 0 113 23"
                  fill="none"
                >
                  <path
                    d="M0 22.5746C5.9742 14.7473 16.9762 8.6408 16.9762 8.6408C16.9762 8.6408 28.4566 14.8512 33.9524 22.5746C28.4595 10.0614 16.9762 0 16.9762 0C16.9762 0 5.9742 9.89146 0 22.5746Z"
                    fill="#FF8A00"
                  />
                  <path
                    d="M0.0869141 22.4772C6.06259 19.1657 17.0631 16.5819 17.0631 16.5819C17.0631 16.5819 28.5435 19.2103 34.0393 22.4772C28.5479 17.1825 17.0631 12.9272 17.0631 12.9272C17.0631 12.9272 6.06259 17.1115 0.0869141 22.4772Z"
                    fill="#FF8A00"
                  />
                  <path
                    d="M0.0869141 22.4773C6.06259 21.0765 17.0631 19.9793 17.0631 19.9793C17.0631 19.9793 28.5435 21.0897 34.0393 22.4724C28.5479 20.2334 17.0631 18.4316 17.0631 18.4316C17.0631 18.4316 6.06259 20.207 0.0869141 22.4773Z"
                    fill="#FF8A00"
                  />
                  <path
                    d="M44.3975 17.2946C41.8435 17.2946 40.1615 16.0909 40.0303 14.0925L40.0226 13.9768H41.9284L41.9439 14.0694C42.0905 15.0261 43.0704 15.6203 44.467 15.6203C45.8713 15.6203 46.7509 14.9953 46.7509 14.0385V14.0308C46.7509 13.1975 46.1722 12.7499 44.737 12.449L43.5411 12.2021C41.3497 11.7469 40.2695 10.7284 40.2695 9.06943V9.06172C40.2772 7.10187 41.9979 5.77473 44.3975 5.77473C46.828 5.77473 48.4175 7.05557 48.5333 8.96141L48.541 9.09258H46.6351L46.6197 8.99999C46.4885 8.02778 45.6321 7.44909 44.3821 7.44909C43.0781 7.4568 42.2679 8.06636 42.2679 8.95369V8.96141C42.2679 9.74844 42.8775 10.2114 44.2201 10.4892L45.4237 10.7361C47.7385 11.2145 48.7493 12.1558 48.7493 13.8919V13.8996C48.7493 15.9752 47.1135 17.2946 44.3975 17.2946Z"
                    fill="#10312B"
                  />
                  <path
                    d="M50.0456 17.1017V8.92283H51.9669V10.2345H52.0054C52.3527 9.33949 53.1937 8.75308 54.2739 8.75308C55.4159 8.75308 56.2415 9.35492 56.5424 10.4043H56.5887C56.9822 9.38579 57.9544 8.75308 59.135 8.75308C60.7476 8.75308 61.8047 9.84874 61.8047 11.4845V17.1017H59.8834V11.9629C59.8834 10.9521 59.3587 10.3734 58.4174 10.3734C57.4915 10.3734 56.8588 11.0601 56.8588 12.0478V17.1017H54.9915V11.8626C54.9915 10.9444 54.436 10.3734 53.5409 10.3734C52.615 10.3734 51.9669 11.0987 51.9669 12.0941V17.1017H50.0456Z"
                    fill="#10312B"
                  />
                  <path
                    d="M65.763 17.2406C64.1272 17.2406 63.0238 16.2298 63.0238 14.7715V14.7561C63.0238 13.3055 64.1503 12.4336 66.1333 12.3101L68.2707 12.179V11.6157C68.2707 10.7901 67.7305 10.2886 66.7583 10.2886C65.8478 10.2886 65.2923 10.7129 65.1688 11.3148L65.1534 11.3842H63.371L63.3787 11.2916C63.4945 9.84103 64.7522 8.75308 66.8278 8.75308C68.8725 8.75308 70.1919 9.83331 70.1919 11.4768V17.1017H68.2707V15.844H68.2244C67.7537 16.7005 66.8432 17.2406 65.763 17.2406ZM64.9374 14.6944C64.9374 15.3656 65.4929 15.7746 66.334 15.7746C67.4373 15.7746 68.2707 15.0416 68.2707 14.0694V13.4521L66.4034 13.5678C65.4543 13.6296 64.9374 14.0385 64.9374 14.6866V14.6944Z"
                    fill="#10312B"
                  />
                  <path
                    d="M71.7428 17.1017V8.92283H73.6641V10.3348H73.7027C73.9573 9.34721 74.6363 8.75308 75.5777 8.75308C75.8168 8.75308 76.0406 8.79166 76.1872 8.83024V10.5663C76.0252 10.5046 75.732 10.4583 75.4079 10.4583C74.32 10.4583 73.6641 11.145 73.6641 12.3564V17.1017H71.7428Z"
                    fill="#10312B"
                  />
                  <path
                    d="M80.2149 17.2638C78.502 17.2638 77.6918 16.5693 77.6918 14.8873V10.4043H76.5344V8.92283H77.6918V6.84724H79.644V8.92283H81.164V10.4043H79.644V14.7252C79.644 15.5277 79.9989 15.7823 80.701 15.7823C80.8862 15.7823 81.0328 15.7592 81.164 15.7514V17.1943C80.9402 17.2252 80.6007 17.2638 80.2149 17.2638Z"
                    fill="#10312B"
                  />
                  <path
                    d="M90.6855 17.2946C87.4834 17.2946 85.4618 15.0879 85.4618 11.5308V11.5231C85.4618 7.96605 87.4911 5.77473 90.6855 5.77473C93.2472 5.77473 95.1299 7.37193 95.4231 9.64041L95.4308 9.71757H93.4786L93.4401 9.57097C93.116 8.29784 92.1361 7.5031 90.6855 7.5031C88.7411 7.5031 87.4988 9.054 87.4988 11.5231V11.5308C87.4988 14.0076 88.7488 15.5663 90.6855 15.5663C92.1052 15.5663 93.1006 14.8024 93.4632 13.4289L93.4864 13.3518H95.4385L95.4231 13.4289C95.1376 15.7129 93.2472 17.2946 90.6855 17.2946Z"
                    fill="#10312B"
                  />
                  <path
                    d="M97.7764 7.75001C97.1746 7.75001 96.7039 7.27162 96.7039 6.70064C96.7039 6.11423 97.1746 5.64355 97.7764 5.64355C98.3783 5.64355 98.8412 6.11423 98.8412 6.70064C98.8412 7.27162 98.3783 7.75001 97.7764 7.75001ZM96.8119 17.1017V8.92283H98.7332V17.1017H96.8119Z"
                    fill="#10312B"
                  />
                  <path
                    d="M103.409 17.2638C101.696 17.2638 100.886 16.5693 100.886 14.8873V10.4043H99.7286V8.92283H100.886V6.84724H102.838V8.92283H104.358V10.4043H102.838V14.7252C102.838 15.5277 103.193 15.7823 103.895 15.7823C104.08 15.7823 104.227 15.7592 104.358 15.7514V17.1943C104.134 17.2252 103.795 17.2638 103.409 17.2638Z"
                    fill="#10312B"
                  />
                  <path
                    d="M106.773 19.8177C106.403 19.8177 106.017 19.7714 105.786 19.7329V18.2668C105.932 18.2977 106.156 18.3363 106.426 18.3363C107.159 18.3363 107.568 18.128 107.815 17.4412L107.931 17.1094L104.991 8.92283H107.09L109.003 15.466H109.057L110.978 8.92283H113L110.06 17.3795C109.435 19.1773 108.478 19.8177 106.773 19.8177Z"
                    fill="#10312B"
                  />
                </svg>
              </Link>
            </a>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navbar-nav m-auto">
            {/* <button className="homebtnns">
                  Home
                </button> */}

            <li class="nav-item active">
              <HashLink
                to="#navbar"
                onClick={handleCloseSidebar}
                style={
                  isActive("")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Home
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="#about"
                onClick={handleCloseSidebar}
                style={
                  isActive("#about")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                About us
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="#benefits"
                onClick={handleCloseSidebar}
                style={
                  isActive("#benefits")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Benefits
              </HashLink>
            </li>

            <li className="nav-item">
              <HashLink
                to="#information"
                onClick={handleCloseSidebar}
                style={
                  isActive("#information")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
              Fraction
              </HashLink>
            </li>
            <li className="nav-item ">
              <HashLink
                to="#roadmap"
                onClick={handleCloseSidebar}
                style={
                  isActive("#roadmap")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Roadmap
              </HashLink>
            </li>
            <li className="nav-item ">
              <HashLink
                to="#ourteamsec"
                onClick={handleCloseSidebar}
                style={
                  isActive("#ourteamsec")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Team
              </HashLink>
            </li>
            <li className="nav-item ">
              <HashLink
                to="#faqs"
                onClick={handleCloseSidebar}
                style={
                  isActive("#faqs")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                FAQ
              </HashLink>
            </li>
            <li className="nav-item ">
              <HashLink
                to="#"
                style={
                  isActive("#")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Whitepaper
              </HashLink>
            </li>
            <li className="nav-item ">
              <HashLink
                to="/join"
                style={
                  isActive("#")
                    ? {
                        color: "#FF8A00",
                      }
                    : {}
                }
              >
                Join whitelist
              </HashLink>
            </li>
            {/* <button data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={handleCloseSidebar}>
              Connect Wallet
            </button> */}
            {/* {
              account ?
                <button className="dissconnect-btn"
                  class="btn button-hedaer"
                  onClick={connectMetaMask1}>
                  Disconnect
                </button>
                :
                <button
                  onClick={() => { setModalOpen(true); handleCloseSidebar(); }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  class="btn button-hedaer"
                >
                  Connect Wallet
                </button>
            } */}

            {token ? (
              <button
                onClick={() => logoutUserHandle()}
                // data-bs-toggle="modal"
                // data-bs-target="#exampleModal"
                class="btn button-hedaer"
              >
                Logout
              </button>
            ) : (
              <>
                <button
                  className="btn button-hedaer my-1 mt-3"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>

                <button
                  className="btn button-hedaer my-1"
                  onClick={() => navigate(Environment.UserDashboard + "signup")}
                >
                  Signup
                </button>
              </>
            )}

            {location?.pathname == "/villaa/:id" ? (
              <>
                {account ? (
                  <button
                    onClick={() => logoutHandle()}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    class="btn button-hedaer"
                  >
                    Disconnect
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      setModalOpen(true);
                      handleCloseSidebar();
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    class="btn button-hedaer"
                  >
                    Connect Wallet
                  </button>
                )}
              </>
            ) : null}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
};

export default Navbar;
